// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__VikmY","list":"BalanceDue_list__2C-9c","listRow":"BalanceDue_listRow__1V4qs","total":"BalanceDue_total__8MeVR"};